import cn from '@integrations/classnames'
import type { CheckoutDetails, PaymentPreview } from 'mmfintech-backend-api/types'
import { formatMoney, tr } from 'mmfintech-commons'

import { LabelValue } from 'mmfintech-portal-commons'

import { TransactionActionModalPreview } from '../../TransactionActionModalSurface'

interface Props {
  previewData?: PaymentPreview
  checkoutDetails?: CheckoutDetails
}

function RefundPreview({ previewData, checkoutDetails }: Props) {
  const { fee, feeCurrency, walletAmount, walletCurrency } = previewData || {}
  const { customerName, customerEmail } = checkoutDetails || {}

  return (
    <>
      <h3>{tr('FRONTEND.TRANSACTIONS.REFUND_MODAL.PREVIEW_TITLE', 'Refund preview')}</h3>

      <TransactionActionModalPreview className={cn('refund-preview-content')}>
        <LabelValue
          label={tr('FRONTEND.TRANSACTIONS.REFUND_MODAL.CUSTOMER_NAME', 'Customer name')}
          value={customerName}
          colon
          dataTest='customer-name'
        />
        <LabelValue
          label={tr('FRONTEND.TRANSACTIONS.REFUND_MODAL.CUSTOMER_EMAIL', 'Customer email')}
          value={customerEmail}
          colon
          dataTest='customer-email'
        />
        <LabelValue
          label={tr('FRONTEND.TRANSACTIONS.REFUND_MODAL.AMOUNT', 'Amount')}
          value={walletAmount > 0 && walletCurrency?.length ? formatMoney(walletAmount, walletCurrency) : null}
          colon
          dataTest='net-amount'
        />
        {fee > 0 ? (
          <LabelValue
            label={tr('FRONTEND.TRANSACTIONS.REFUND_MODAL.FEE', 'Fee')}
            value={formatMoney(fee, feeCurrency)}
            colon
            dataTest='fee-amount'
          />
        ) : null}
      </TransactionActionModalPreview>
    </>
  )
}

export default RefundPreview
